import React from 'react';


const MessageA1 = (props) => {

    //    const playing = () =>  {
    //    console.log("palying")
    //     var audio = new Audio('https://www.fesliyanstudios.com/play-mp3/38');
    //     audio.play();
    //   }


    return(
        <span className={!props.disable ? "chat-label action-tab ":"chat-labelnohover action-tab"} id="main-tab1" style={{color:props.disable && 'grey'}} onClick={()=>{
          if(!props.disable)
          {  props.handleClick(props.item.code);props.setTextOnClick(props.item.text);}}}>{props.item.text}</span>
    )
}


export default MessageA1;